import React, { useEffect, useRef, useState } from 'react';
import { Button, Grid } from '@mui/material';
import SelectionChip from "../../../components/SelectionChip/SelectionChip";
import { Accordion, AccordionDetails, AccordionSummary } from '../../../components/MuiCustomComponent/MuiCustomComponent';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import InputBase from "@mui/material/InputBase";
import styles from "./generic-accordion-card.module.scss";
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from '@mui/material/styles';

const GenericAccordionCard = ({ title, children, onReset, onSearch, searchSummary, onAccordionToggle, validBillingDate, isActionDisable={} , setPage = () => {}, setOffset = () => {}}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const theme = useTheme();
  const isTabletOrSmaller = useMediaQuery(theme?.breakpoints?.down('lg')) || false;
  localStorage.setItem("drawerSelectedItem", "Reports");

  const accordionRef = useRef(null);
  const [isAccordionOpen, setIsAccordionOpen] = useState(!(location.pathname.includes("quote") && sessionStorage.getItem("isFromOrderApproval")));
  
  const toggleGenericAccordion = () => {
    setIsAccordionOpen(!isAccordionOpen);
    if (onAccordionToggle) {
      onAccordionToggle(!isAccordionOpen);
    }
  };
  const handleReset = () => {
    if (onReset) onReset();
    setIsAccordionOpen(true);
    if (onAccordionToggle) onAccordionToggle(false);
  };

  const handleSearch = (isSearching=false) => {

    if (isSearching) {
      setOffset(1);
      setPage(0);
    }

    if (onSearch) onSearch();
    setIsAccordionOpen(false);
    if (onAccordionToggle) onAccordionToggle(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (accordionRef.current && !accordionRef.current.contains(event.target) && !document.querySelector('div[role="dialog"]') && !document.querySelector('ul[role="listbox"]')) {
        setIsAccordionOpen(false);
        if (onAccordionToggle) onAccordionToggle(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onAccordionToggle]);
  return (
    <div className={styles.GenericAccordionCard} data-testid="GenericAccordionCard">
      <Grid container className={styles.accordianBottomTop10px}>
        <Grid item container
          className={styles.accordianBottomTop10px}>
          <Grid item md={6} xs={12}>
            <div className={`${styles.searchContainer1Style} toast-container`} ref={accordionRef}>
              <Accordion
                data-testid="toggleGenericAccordion"
                expanded={isAccordionOpen}
                onChange={toggleGenericAccordion}
                className={styles.customGenericAccordion}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon style={{ cursor: "pointer" }} />}
                  aria-controls="panel-content"
                  id="panel-header"
                  className={styles.customGenericAccordionSummary}
                >
                  <div className="searchFilterIcon"  >
                    <FilterAltIcon sx={{ fontSize: "1.2rem" }} />
                    {searchSummary == "" &&
                      (<InputBase
                        placeholder={`Search ${title}`}
                        style={{ width: isTabletOrSmaller? '179px' : '300px'}}
                        sx={{
                          ...(isTabletOrSmaller && {
                            '& input': {
                              textOverflow: 'ellipsis'
                            },
                          }),
                        }}
                        className="filterIconInputBase"
                      />)
                    }
                  </div>
                  {searchSummary && (
                    <div style={{ marginTop: "8px" }} data-testid="recurringSummary">
                      {searchSummary.map((item, index) => {
                        const parts = item?.split(":") ?? [];
                        const chipLabel = parts.length === 1 ? undefined : parts[0];
                        const chipValue = parts.length === 1 ? parts[0] : parts[1]?.trim();
                        return (
                          <SelectionChip
                            key={item}
                            data-testid='chip-id'
                            label={chipLabel}
                            value={chipValue}
                            className="marginRightEight marginRightBottom height_fit_content"
                            onMouseDown={(e) => e.stopPropagation()}
                          />
                        );
                      })}
                    </div>
                  )}
                </AccordionSummary>
                <AccordionDetails className={styles.customGenericAccordionDetails}>
                  <div>{children}</div>
                  <Grid item container
                    className={styles.customResetButton}>
                    <Button
                      color='secondary'
                      size="medium"
                      onClick={handleReset}
                      data-testid="handleResetButton">
                      {t("PatientsListing.reset")}
                    </Button>
                    <Button
                      color='primary'
                      size="medium"
                      onClick={() => handleSearch(true)}
                      disabled = {validBillingDate || isActionDisable?.search}
                      data-testid="handleSearchButton">
                      {t("PatientsListing.search")}
                    </Button>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
export default GenericAccordionCard;